export default {
    name: " FF Sea Import ",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true
    },
    departmentName: "Sea Freight",
    finalPagePermision: "Sea Import",
    children: [

        {
            name: "FCL/LCL Import Details",
            path: "/seaImport/viewSeaImportDetails",
            permissionName: 'Sea Import',
            keywords: ['Sea Import', ' FF Sea Import ', 'FCL/LCL Details'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/seaImport/viewSeaImportDetails.vue"),
            finalPagePermision: "Sea Import",
        },

        {
            name: "FF Consolidation Import Details",
            path: "/conSeaImport/conviewSeaImpDetails",
            permissionName: 'Sea Import',
            keywords: ['Sea Import', ' FF Sea Import ', 'Consolidation Details', 'FF Sea Import Consolidation Details'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/conSeaImport/conviewSeaImpDetails.vue"),
            finalPagePermision: "Sea Import",
        },
        {
            name: "FF Import Reports",
            path: "/reports/freightImportReports",
            permissionName: 'Sea Import',
            keywords: ['Sea Import', ' FF Sea Import ', 'FF Import Reports'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/reports/freightImportReports.vue"),
            finalPagePermision: "Sea Import",
        },

    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/seaImport.js